<div class="centered" *ngIf="imageUrl">
	<img [src]="imageUrl" width="50%"/>
</div>
